import { render, staticRenderFns } from "./BuildingSocietyMessages.vue?vue&type=template&id=4b01218c&scoped=true&"
import script from "./BuildingSocietyMessages.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01218c",
  null
  
)

export default component.exports